import { Autocomplete, Box, TextField } from '@mui/material';
import React, { useState } from 'react';

import { usePatients } from '../api/index.js';
import AutocompleteOptions from '../components/AutocompleteOptions.js';
import LogsContainer from '../components/Logs/LogsContainer.js';
import { type Patient } from '../models/index.js';

const Logs = () => {
  const { data = [] } = usePatients({
    includeInactive: true,
    includeCameras: false,
    includeMatched: false,
  });
  const [selectedPatient, setSelectedPatient] = useState<Patient | null>(null);

  return (
    <Box sx={{ m: 2 }}>
      <Box sx={{ mb: 2, width: 400 }}>
        <Autocomplete
          value={selectedPatient}
          onChange={(_: any, value: Patient | null) => {
            setSelectedPatient(value);
          }}
          id={'patient-select'}
          options={data}
          isOptionEqualToValue={(option, value: Patient) => option.id === value.id}
          getOptionLabel={(patient: Patient) => `${patient.firstName} ${patient.lastName}`}
          renderInput={(params) => (
            <TextField
              {...params}
              label={'Patient'}
              helperText={'Please select a patient in order to view logs and reports'}
            />
          )}
          renderOption={({ key, ...props }, option, { inputValue }) => (
            <AutocompleteOptions option={`${option.firstName} ${option.lastName}`} value={inputValue} key={key} {...props} />
          )}
        />
      </Box>
      <LogsContainer patientId={selectedPatient?.id} />
    </Box>
  );
};

export default Logs;
